export enum GenerateSamplesStep {
    SampleType = 1,
    ManualSamples = 2,
}
